import { render, staticRenderFns } from "./kbji.vue?vue&type=template&id=bdc19f3c"
import script from "./kbji.vue?vue&type=script&lang=js"
export * from "./kbji.vue?vue&type=script&lang=js"
import style0 from "./kbji.vue?vue&type=style&index=0&id=bdc19f3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports